import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DdrQueueState {
  queue: any[];
}

const initialState: DdrQueueState = {
  queue: [],
};

const ddrQueueSlice = createSlice({
  name: "ddrQueue",
  initialState,
  reducers: {
    addToQueue(state, action: PayloadAction<any>) {
      const exists = state.queue.some(
        (a) => a.article_id === action.payload.article_id
      );
      if (!exists) {
        state.queue.push(action.payload);
      }
    },
    removeFromQueue(state, action: PayloadAction<string>) {
      state.queue = state.queue.filter(
        (a) => a.article_id !== action.payload
      );
    },
    clearQueue(state) {
      state.queue = [];
    },
  },
});

export const { addToQueue, removeFromQueue, clearQueue } =
  ddrQueueSlice.actions;
export default ddrQueueSlice.reducer;
